import type { PluginConfig } from './types'
import type { UserSettings } from '~common/storage/users'

export const PLUGIN_CONFIGS = {
    'datev-classify-transactions': {
        id: 'datev-classify-transactions' as const,
        title: 'Classify Transactions (Datev)',
        description:
            'Auto-classify transactions for booking accounts in DATEV format.',
        requiresSettings: {
            section: 'booking-categories',
            check: (settings: unknown) => {
                const userSettings = settings as UserSettings | null | undefined
                const pluginConfig =
                    userSettings?.plugins?.['datev-classify-transactions']
                return !!pluginConfig?.config?.kontenrahmen
            },
        },
        visible: false,
    },
    'sync-to-qonto': {
        id: 'sync-to-qonto' as const,
        title: 'Sync to Qonto',
        description: 'Automatically upload invoices to Qonto.',
        requiresSettings: {
            section: 'plugin-settings',
            check: (settings: unknown) => {
                const userSettings = settings as UserSettings | null | undefined
                const pluginConfig = userSettings?.plugins?.['sync-to-qonto']
                return !!pluginConfig?.refreshToken
            },
        },
        visible: false,
    },
    'get-my-invoices': {
        id: 'get-my-invoices' as const,
        title: 'Sync with GetMyInvoices',
        icon: 'getmyinvoices',
        description:
            'Automatically sync bank accounts, transactions, and invoices from GetMyInvoices.',
        requiresSettings: {
            section: 'plugin-settings',
            check: (settings: unknown) => {
                const userSettings = settings as UserSettings | null | undefined
                const pluginConfig = userSettings?.plugins?.['get-my-invoices']
                return !!pluginConfig?.apiKey
            },
        },
        visible: true,
    },
} as const satisfies Record<string, PluginConfig>

export type PluginId = keyof typeof PLUGIN_CONFIGS

export function getAllPluginConfigs(): PluginConfig[] {
    return Object.values(PLUGIN_CONFIGS)
}

export function getPluginConfig(
    pluginId: PluginId,
    settings: UserSettings | null | undefined,
): NonNullable<UserSettings['plugins']>[PluginId] | undefined {
    return settings?.plugins?.[pluginId]
}

export function getDatevPluginConfig(
    settings: UserSettings | null | undefined,
):
    | NonNullable<UserSettings['plugins']>['datev-classify-transactions']
    | undefined {
    return settings?.plugins?.['datev-classify-transactions']
}
